import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { notImplemented, warning, StringUtilities } from '@awayfl/swf-loader';
import { axCoerceString, ObjectEncoding, AMF3 } from '@awayfl/avm2';
import { ByteArray } from '../utils/ByteArray';
var _sharedObjectStorage;
function getSharedObjectStorage() {
    /*if (!_sharedObjectStorage) {
      if (typeof ShumwayCom !== 'undefined' && ShumwayCom.createSpecialStorage) {
        _sharedObjectStorage = ShumwayCom.createSpecialStorage();
      } else {
        _sharedObjectStorage = (<any>window).sessionStorage;
      }
    }
    release || assert(_sharedObjectStorage, "SharedObjectStorage is not available.");
    */
    if (typeof (Storage) !== "undefined") {
        _sharedObjectStorage = localStorage;
    }
    return _sharedObjectStorage;
}
var SharedObject = /** @class */ (function (_super) {
    __extends(SharedObject, _super);
    //for AVM1:
    //public fps: number;
    function SharedObject() {
        return _super.call(this) || this;
    }
    Object.defineProperty(SharedObject, "defaultObjectEncoding", {
        get: function () {
            notImplemented("public flash.net.SharedObject::static defaultObjectEncoding");
            return;
        },
        set: function (version /*uint*/) {
            notImplemented("public flash.net.SharedObject::static defaultObjectEncoding");
            return;
        },
        enumerable: true,
        configurable: true
    });
    SharedObject.deleteAll = function (url) {
        notImplemented("public flash.net.SharedObject::static deleteAll");
        return;
    };
    SharedObject.getDiskUsage = function (url) {
        notImplemented("public flash.net.SharedObject::static getDiskUsage");
        return 0;
    };
    SharedObject.getLocal = function (name, localPath, secure) {
        name = axCoerceString(name);
        localPath = axCoerceString(localPath);
        secure = !!secure;
        var path = (localPath || '') + '/' + name;
        /*if (this._sharedObjects[path]) {
        return this._sharedObjects[path];
        }*/
        var encodedData = getSharedObjectStorage().getItem(path);
        var data;
        var encoding = this._defaultObjectEncoding;
        if (encodedData) {
            try {
                var bytes = StringUtilities.decodeRestrictedBase64ToBytes(encodedData);
                //console.log("loaded bytes", bytes);
                var serializedData = new ByteArray(bytes.length);
                serializedData.sec = this.sec;
                serializedData.setArrayBuffer(bytes.buffer);
                //console.log("serializedData.arraybytes", serializedData.arraybytes);
                //	unexpected("Object Encoding");
                //}
                data = AMF3.read(serializedData); //serializedData.readObject();
                //encoding = serializedData.objectEncoding;
            }
            catch (e) {
                warning('Error encountered while decoding LocalStorage entry. Resetting data.');
            }
            if (!data || typeof data !== 'object') {
                data = this.sec.createObject();
            }
        }
        else {
            data = this.sec.createObject();
        }
        var so = new this.sec.flash.net.SharedObject();
        so._path = path;
        so._objectEncoding = encoding;
        so._data = data;
        return so;
    };
    SharedObject.getRemote = function (name, remotePath, persistence, secure) {
        return new this.sec.flash.net.SharedObject();
    };
    SharedObject.prototype.flush = function (minDiskSpace) {
        if (minDiskSpace === void 0) { minDiskSpace = 0; }
        /*if (typeof (Storage) !== "undefined") {
            localStorage.setItem(this._object_name, JSON.stringify(this._data));
        }
        else {
            console.log("no local storage available");

        }*/
        minDiskSpace = minDiskSpace | 0;
        // Check if the object is empty. If it is, don't create a stored object if one doesn't exist.
        var isEmpty = true;
        for (var key in this._data) {
            if (this._data.hasOwnProperty(key)) {
                isEmpty = false;
                break;
            }
        }
        if (isEmpty && !getSharedObjectStorage().getItem(this._path)) {
            return;
        }
        var serializedData = new ByteArray();
        serializedData.sec = this.sec;
        //serializedData.objectEncoding = this._objectEncoding;
        //serializedData.writeObject(this._data);
        AMF3.write(serializedData, this._data);
        //data = AMF3.write(<any>serializedData); //serializedData.readObject();
        var bytes = new Uint8Array(serializedData.arraybytes);
        var encodedData = StringUtilities.base64EncodeBytes(bytes);
        /*if (!release) {
          var decoded = StringUtilities.decodeRestrictedBase64ToBytes(encodedData);
          assert(decoded.byteLength === bytes.byteLength);
          for (var i = 0; i < decoded.byteLength; i++) {
            assert(decoded[i] === bytes[i]);
          }
        }*/
        getSharedObjectStorage().setItem(this._path, encodedData);
    };
    Object.defineProperty(SharedObject.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (object) {
            this._data = object;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedObject.prototype, "objectEncoding", {
        get: function () {
            notImplemented("public flash.net.SharedObject::get objectEncoding");
            return;
        },
        set: function (version /*uint*/) {
            notImplemented("public flash.net.SharedObject::set objectEncoding");
            return;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedObject.prototype, "client", {
        get: function () {
            notImplemented("public flash.net.SharedObject::get client");
            return;
            // return this._client;
        },
        set: function (object) {
            notImplemented("public flash.net.SharedObject::set client");
            return;
            // this._client = object;
        },
        enumerable: true,
        configurable: true
    });
    SharedObject.prototype.setDirty = function (propertyName) {
        notImplemented("public flash.net.SharedObject::setDirty");
        return;
    };
    SharedObject.prototype.connect = function (myConnection, params) {
        if (params === void 0) { params = null; }
        notImplemented("public flash.net.SharedObject::connect");
        return;
    };
    SharedObject.prototype.send = function () {
        notImplemented("public flash.net.SharedObject::send");
        return;
    };
    SharedObject.prototype.close = function () {
        notImplemented("public flash.net.SharedObject::close");
        return;
    };
    SharedObject.prototype.clear = function () {
        notImplemented("public flash.net.SharedObject::clear");
        return;
    };
    Object.defineProperty(SharedObject.prototype, "size", {
        get: function () {
            notImplemented("public flash.net.SharedObject::get size");
            return;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SharedObject.prototype, "fps", {
        set: function (updatesPerSecond) {
            notImplemented("public flash.net.SharedObject::set fps");
            return;
        },
        enumerable: true,
        configurable: true
    });
    SharedObject.prototype.setProperty = function (propertyName, value) {
        if (value === void 0) { value = null; }
        notImplemented("public flash.net.SharedObject::setProperty");
        return;
    };
    SharedObject._defaultObjectEncoding = ObjectEncoding.DEFAULT;
    return SharedObject;
}(ASObject));
export { SharedObject };
